'use strict';

var React = require('react');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/Show.tsx
var SvgShow = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M6.094 8.055c-1.559 1.28-2.646 2.782-3.195 3.637a3.305 3.305 0 0 0-.128.208.166.166 0 0 0-.018.043l-.001.01a.508.508 0 0 0 .001.104c.003.011.006.02.018.043.021.04.053.091.128.208.549.855 1.636 2.357 3.195 3.637C7.651 17.225 9.635 18.25 12 18.25c2.365 0 4.349-1.026 5.906-2.305 1.559-1.28 2.646-2.782 3.195-3.637.075-.117.107-.168.128-.208a.165.165 0 0 0 .018-.043l.001-.01a.54.54 0 0 0 0-.094l-.001-.01a.165.165 0 0 0-.018-.043 3.243 3.243 0 0 0-.128-.208c-.549-.855-1.636-2.357-3.195-3.637C16.349 6.775 14.365 5.75 12 5.75c-2.365 0-4.349 1.026-5.906 2.305Zm-.952-1.16C6.869 5.478 9.179 4.25 12 4.25c2.821 0 5.131 1.227 6.858 2.646 1.725 1.417 2.91 3.059 3.505 3.986l.023.035c.12.187.254.395.323.69.055.236.055.55 0 .787-.069.294-.203.502-.323.69l-.023.034c-.595.927-1.78 2.57-3.505 3.986-1.727 1.42-4.037 2.646-6.858 2.646-2.821 0-5.131-1.227-6.858-2.646-1.725-1.417-2.91-3.059-3.505-3.986l-.023-.035c-.12-.187-.254-.395-.323-.69a1.893 1.893 0 0 1 0-.787c.069-.294.203-.502.323-.69l.023-.034c.594-.927 1.78-2.57 3.505-3.986ZM12 9.75c-1.28 0-2.297 1.018-2.297 2.25S10.72 14.25 12 14.25c1.28 0 2.297-1.018 2.297-2.25S13.28 9.75 12 9.75ZM8.203 12c0-2.082 1.71-3.75 3.797-3.75 2.086 0 3.797 1.668 3.797 3.75s-1.71 3.75-3.797 3.75c-2.086 0-3.797-1.668-3.797-3.75Z" }));
var Show_default = SvgShow;

module.exports = Show_default;
